CamposExtraIframeCtrl.$inject = ['$scope', '$sce'];

export default function CamposExtraIframeCtrl($scope, $sce) {

    var campExtIframe = this;

    // Helper function for checking if a value is set and not empty
    function issetAndNotEmpty(value) {
        return value !== undefined && value !== null && value !== '';
    }

    campExtIframe.claseRow = issetAndNotEmpty(campExtIframe.claseRow) ? campExtIframe.claseRow == 'true' : true;

    campExtIframe.mostrarIframe = false;
    campExtIframe.iframeUrl = null;
    $scope.trustedUrl = null;

    // Check if campoExtra exists before accessing its properties
    if (campExtIframe.campoExtra) {
        console.log(campExtIframe.campoExtra.json);
        if (issetAndNotEmpty(campExtIframe.campoExtra.json)) {
            try {
                const jsonData = JSON.parse(campExtIframe.campoExtra.json);
                if (jsonData && jsonData.url) {
                    campExtIframe.iframeUrl = jsonData.url;
                    $scope.trustedUrl = $sce.trustAsResourceUrl(jsonData.url);
                } else if (issetAndNotEmpty(campExtIframe.campoExtra.valor)) {
                    campExtIframe.iframeUrl = campExtIframe.campoExtra.valor;
                    $scope.trustedUrl = $sce.trustAsResourceUrl(campExtIframe.campoExtra.valor);
                }
            } catch (e) {
                if (issetAndNotEmpty(campExtIframe.campoExtra.valor)) {
                    campExtIframe.iframeUrl = campExtIframe.campoExtra.valor;
                    $scope.trustedUrl = $sce.trustAsResourceUrl(campExtIframe.campoExtra.valor);
                }
                console.warn("El valor no es un JSON válido:", e);
            }
        } else if (issetAndNotEmpty(campExtIframe.campoExtra.valor)) {
            campExtIframe.iframeUrl = campExtIframe.campoExtra.valor;
            $scope.trustedUrl = $sce.trustAsResourceUrl(campExtIframe.campoExtra.valor);
        }
    }

    campExtIframe.cambiaIframe = function (data) {
        if (campExtIframe.campoExtra) {
            campExtIframe.campoExtra.valor = data;
            campExtIframe.hasError = data == null;
            campExtIframe.campoExtra.changed = true;
        }
    };

    campExtIframe.abrirIframe = function () {
        if (campExtIframe.iframeUrl) {
            var url = campExtIframe.iframeUrl;
            url = url.replace('&app_ciudadanos=1', '');

            // Determinar origen basado en el contexto de la aplicación
            var origen = '';
            var id = campExtIframe.modelId;

            // Examinar la URL actual o el contexto para determinar origen
            if (window.location.href.indexOf('/incidencias') !== -1) {
                origen = 'incidencias';
            } else if (window.location.href.indexOf('/obras') !== -1) {
                origen = 'tareas';
            }

            // Añadir parámetros a la URL
            if (origen === 'tareas') {
                if (campExtIframe.campoExtra.tabla == 'incidencias') id = id + 1;
                url += (url.indexOf('?') !== -1 ? '&' : '?') + 'tarea_id=' + id;
            } else {
                url += (url.indexOf('?') !== -1 ? '&' : '?') + 'incidencia_id=' + id;
            }

            if (SigoAutentificacionInfraestructuras) {
                url += (url.indexOf('?') !== -1 ? '&' : '?') + 'token=' + SigoAutentificacionInfraestructuras.token;
                url += (url.indexOf('?') !== -1 ? '&' : '?') + 'user=' + SigoAutentificacionInfraestructuras.user;
            }

            $scope.trustedUrl = $sce.trustAsResourceUrl(url);
            campExtIframe.mostrarIframe = true;
        }
    };

    campExtIframe.cerrarIframe = function () {
        campExtIframe.mostrarIframe = false;
    };
}